import { render } from "./TskSelectNeedle.vue?vue&type=template&id=679911dc&scoped=true"
import script from "./TskSelectNeedle.vue?vue&type=script&lang=js"
export * from "./TskSelectNeedle.vue?vue&type=script&lang=js"

import "./TskSelectNeedle.vue?vue&type=style&index=0&id=679911dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679911dc"]])

export default __exports__